import { combineReducers } from "redux";
import {
    REQUEST_SUBMIT_FILE_ARCHIVE_DATA,
    SUCCESS_SUBMIT_FILE_ARCHIVE_DATA,
    FAILURE_SUBMIT_FILE_ARCHIVE_DATA,
    REQUEST_SUBMIT_ARCHIVE_DATA_BLUE,
    SUCCESS_SUBMIT_ARCHIVE_DATA_BLUE,
    FAILURE_SUBMIT_ARCHIVE_DATA_BLUE,
    REQUEST_SUBMIT_ARCHIVE_DATA,
    SUCCESS_SUBMIT_ARCHIVE_DATA,
    FAILURE_SUBMIT_ARCHIVE_DATA,
    REQUEST_SUBMIT_ARCHIVE_HISTORY,
    SUCCESS_SUBMIT_ARCHIVE_HISTORY,
    FAILURE_SUBMIT_ARCHIVE_HISTORY,
    REQUEST_GET_LIST_ARCHIVE,
    SUCCESS_GET_LIST_ARCHIVE,
    FAILURE_GET_LIST_ARCHIVE,
    REQUEST_UPDATE_ARCHIVE,
    SUCCESS_UPDATE_ARCHIVE,
    FAILURE_UPDATE_ARCHIVE,
    REQUEST_UPDATE_EDIT_HISTORY_ARCHIVE,
    SUCCESS_UPDATE_EDIT_HISTORY_ARCHIVE,
    FAILURE_UPDATE_EDIT_HISTORY_ARCHIVE,
    REQUEST_FILE_DOWNLOAD_ARCHIVE,
    SUCCESS_FILE_DOWNLOAD_ARCHIVE,
    FAILURE_FILE_DOWNLOAD_ARCHIVE,
    REQUEST_GET_ARCHIVE_EDIT_HISTORY,
    SUCCESS_GET_ARCHIVE_EDIT_HISTORY,
    FAILURE_GET_ARCHIVE_EDIT_HISTORY,
    REQUEST_GET_ARCHIVE_SEARCH_RESULT,
    SUCCESS_GET_ARCHIVE_SEARCH_RESULT,
    FAILURE_GET_ARCHIVE_SEARCH_RESULT,
} from "../Constant/archive";

const initialState = {
    fileArchiveData: {
        success: '',
        ivpfile_id: '',
        mime_type: '',
        error: "",
    },
    archiveDataBlue: {
        success: '',
        id: '',
        error: "",
    },
    archiveData: {
        success: '',
        id: '',
        error: "",
    },
    archiveHistory: {
        success: '',
        error: "",
    },
    listArchive: [],
    fileDownloadArchive: {
        success: '',
        error: "",
    },
    archiveUpdate: {
        success: '',
        error: "",
    },
    archiveUpdateEditHistory: {
        success: '',
        error: "",
    },
    archiveEditHistory: [],
    error: "",
    loading: false,
    isFetching: false,
}

const dataFileArchive = (state = initialState.fileArchiveData, action) => {
    switch (action.type) {

        case REQUEST_SUBMIT_FILE_ARCHIVE_DATA:
            return {
                ...state,
                success: '',
                ivpfile_id: '',
                mime_type: '',
                error: '',
            }
        case SUCCESS_SUBMIT_FILE_ARCHIVE_DATA:
            return {
                ...state,
                success: action.payload.message,
                ivpfile_id: action.payload.ivpfile_id,
                mime_type: action.payload.mime_type,
                error: '',
            }
        case FAILURE_SUBMIT_FILE_ARCHIVE_DATA:
            return {
                ...state,
                success: '',
                ivpfile_id: '',
                mime_type: '',
                error: action.payload,
            }


        default:
            return state;
    }
};

const dataBlueArchive = (state = initialState.archiveDataBlue, action) => {
    switch (action.type) {

        case REQUEST_SUBMIT_ARCHIVE_DATA_BLUE:
            return {
                ...state,
                success: '',
                id: '',
                error: '',
            }
        case SUCCESS_SUBMIT_ARCHIVE_DATA_BLUE:
            return {
                ...state,
                success: action.payload.message,
                id: action.payload.id,
                error: '',
            }
        case FAILURE_SUBMIT_ARCHIVE_DATA_BLUE:
            return {
                ...state,
                success: '',
                id: '',
                error: action.payload,
            }


        default:
            return state;
    }
};

const dataArchive = (state = initialState.archiveData, action) => {
    switch (action.type) {

        case REQUEST_SUBMIT_ARCHIVE_DATA:
            return {
                ...state,
                success: '',
                id: '',
                error: '',
            }
        case SUCCESS_SUBMIT_ARCHIVE_DATA:
            return {
                ...state,
                success: action.payload.message,
                id: action.payload.id,
                error: '',
            }
        case FAILURE_SUBMIT_ARCHIVE_DATA:
            return {
                ...state,
                success: '',
                id: '',
                error: action.payload,
            }


        default:
            return state;
    }
};

const historyArchive = (state = initialState.archiveHistory, action) => {
    switch (action.type) {

        case REQUEST_SUBMIT_ARCHIVE_HISTORY:
            return {
                ...state,
                success: '',
                error: '',
            }
        case SUCCESS_SUBMIT_ARCHIVE_HISTORY:
            return {
                ...state,
                success: action.payload.message,
                error: '',
            }
        case FAILURE_SUBMIT_ARCHIVE_HISTORY:
            return {
                ...state,
                success: '',
                error: action.payload,
            }


        default:
            return state;
    }
};

const listArchiveData = (state = initialState, action) => {
    switch (action.type) {

        case REQUEST_GET_LIST_ARCHIVE:
        case REQUEST_GET_ARCHIVE_SEARCH_RESULT:
            return {
                ...state,
                listArchive: [],
                error: '',
            }
        case SUCCESS_GET_LIST_ARCHIVE:
        case SUCCESS_GET_ARCHIVE_SEARCH_RESULT:
            return {
                ...state,
                listArchive: action.payload,
                error: '',
            }
        case FAILURE_GET_LIST_ARCHIVE:
        case FAILURE_GET_ARCHIVE_SEARCH_RESULT:
            return {
                ...state,
                listArchive: [],
                error: action.payload,
            }

        default:
            return state;
    }
};

const downloadArchiveFile = (state = initialState.fileDownloadArchive, action) => {
    switch (action.type) {

        case REQUEST_FILE_DOWNLOAD_ARCHIVE:
            return {
                ...state,
                success: '',
                error: '',
            }
        case SUCCESS_FILE_DOWNLOAD_ARCHIVE:
            return {
                ...state,
                // success: action.payload.message,
                success: action.payload,
                error: '',
            }
        case FAILURE_FILE_DOWNLOAD_ARCHIVE:
            return {
                ...state,
                success: '',
                error: action.payload,
            }

        default:
            return state;
    }
};

const updateArchive = (state = initialState.archiveUpdate, action) => {
    switch (action.type) {

        case REQUEST_UPDATE_ARCHIVE:
            return {
                ...state,
                success: '',
                error: '',
            }
        case SUCCESS_UPDATE_ARCHIVE:
            return {
                ...state,
                success: action.payload.message,
                error: '',
            }
        case FAILURE_UPDATE_ARCHIVE:
            return {
                ...state,
                success: '',
                error: action.payload,
            }

        default:
            return state;
    }
};

const updateEditHistoryArchive = (state = initialState.archiveUpdateEditHistory, action) => {
    switch (action.type) {

        case REQUEST_UPDATE_EDIT_HISTORY_ARCHIVE:
            return {
                ...state,
                success: '',
                error: '',
            }
        case SUCCESS_UPDATE_EDIT_HISTORY_ARCHIVE:
            return {
                ...state,
                success: action.payload.message,
                error: '',
            }
        case FAILURE_UPDATE_EDIT_HISTORY_ARCHIVE:
            return {
                ...state,
                success: '',
                error: action.payload,
            }

        default:
            return state;
    }
};

const archiveEditHistoryData = (state = initialState, action) => {
    switch (action.type) {

        case REQUEST_GET_ARCHIVE_EDIT_HISTORY:
            return {
                ...state,
                archiveEditHistory: [],
                error: '',
            }
        case SUCCESS_GET_ARCHIVE_EDIT_HISTORY:
            return {
                ...state,
                archiveEditHistory: action.payload,
                error: '',
            }
        case FAILURE_GET_ARCHIVE_EDIT_HISTORY:
            return {
                ...state,
                archiveEditHistory: [],
                error: action.payload,
            }

        default:
            return state;
    }
};

const isFetching = (state = initialState.isFetching, action) => {
    switch (action.type) {
        case REQUEST_SUBMIT_FILE_ARCHIVE_DATA:
        case REQUEST_SUBMIT_ARCHIVE_DATA_BLUE:
        case REQUEST_SUBMIT_ARCHIVE_DATA:
        case REQUEST_GET_LIST_ARCHIVE:
        case REQUEST_UPDATE_ARCHIVE:
        case REQUEST_UPDATE_EDIT_HISTORY_ARCHIVE:
        case REQUEST_FILE_DOWNLOAD_ARCHIVE:
        case REQUEST_GET_ARCHIVE_EDIT_HISTORY:
            return true;

        case SUCCESS_SUBMIT_FILE_ARCHIVE_DATA:
        case SUCCESS_SUBMIT_ARCHIVE_DATA_BLUE:
        case SUCCESS_SUBMIT_ARCHIVE_DATA:
        case SUCCESS_GET_LIST_ARCHIVE:
        case SUCCESS_UPDATE_ARCHIVE:
        case SUCCESS_UPDATE_EDIT_HISTORY_ARCHIVE:
        case SUCCESS_FILE_DOWNLOAD_ARCHIVE:
        case SUCCESS_GET_ARCHIVE_EDIT_HISTORY:
        case FAILURE_SUBMIT_FILE_ARCHIVE_DATA:
        case FAILURE_SUBMIT_ARCHIVE_DATA_BLUE:
        case FAILURE_SUBMIT_ARCHIVE_DATA:
        case FAILURE_GET_LIST_ARCHIVE:
        case FAILURE_UPDATE_ARCHIVE:
        case FAILURE_UPDATE_EDIT_HISTORY_ARCHIVE:
        case FAILURE_FILE_DOWNLOAD_ARCHIVE:
        case FAILURE_GET_ARCHIVE_EDIT_HISTORY:
            return false;

        default:
            return state;
    }
};

export default combineReducers({
    dataFileArchive,
    dataBlueArchive,
    dataArchive,
    historyArchive,
    listArchiveData,
    downloadArchiveFile,
    updateArchive,
    updateEditHistoryArchive,
    archiveEditHistoryData,
    isFetching,
});

export const selectDataFileArchive = state => state.dataFileArchive;
export const selectDataBlueArchive = state => state.dataBlueArchive;
export const selectDataArchive = state => state.dataArchive;
export const selectHistoryArchive = state => state.historyArchive;

export const selectListArchive = state => state;
export const selectUpdateArchive = state => state.updateArchive;
export const selectUpdateEditHistoryArchive = state => state.updateEditHistoryArchive;
export const selectDownloadArchiveFile = state => state.downloadArchiveFile;
export const selectArchiveEditHistory = state => state;



// export const selectLine = state => state.lines;
// export const selectNewLine = state => state.lines;
// export const selectTranslatedLine = state => state.lines;
